module.exports = __FOREMAN_VENDOR__URIJS__;